import * as React from "react";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { BackdropProvider } from "../context";
import styled from "styled-components";
const _Backdrop = ({ children, ...BackdropProps }) => {
    return (React.createElement(BackdropProvider, { value: {} },
        React.createElement("div", { ...BackdropProps }, children)));
};
_Backdrop.defaultProps = {
    "data-testid": "backdrop",
};
export const Backdrop = styled(_Backdrop) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
`;
//# sourceMappingURL=Backdrop.js.map